






import VueApexCharts from "vue-apexcharts";
import { Vue, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import {
  CategoryChartData,
  CategoryChartSeries
} from "../../models/category-chart-data";
import { invoiceAnalyticsService } from "../../services/analytics.service";
import RecognitionAnalyticsStore from "../../store/recognition-analytics.store";

@Component({
  components: { apexchart: VueApexCharts }
})
export default class RecogByHeaderFieldChart extends Vue {
  private readonly recognitionStore: RecognitionAnalyticsStore = getModule(
    RecognitionAnalyticsStore,
    this.$store
  );
  get recogByHeaderFieldData() {
    return this.recognitionStore.getRecogByHeaderFieldData;
  }
  get dateRange() {
    return this.recognitionStore.getDateRange;
  }
  get selectedSite() {
    return this.recognitionStore.getSelectedSite;
  }
  get searchButtonClicked() {
    return this.recognitionStore.getSearchButtonClicked;
  }
  get includeVsInRecogRates() {
    return this.recognitionStore.getIncludeVsInRecogRates;
  }
  private series: CategoryChartSeries[] = [];
  private chartOptions = {
    chart: {
      fontFamily: "'Lato', sans-serif",
      toolbar: {
        export: {
          csv: {
            filename: `header-field-recognition-${this.dateRange.startDate}-to-${this.dateRange.endDate}`,
            columnDelimiter: ",",
            headerCategory: "Field"
          }
        }
      }
    },
    dataLabels: {
      enabled: true
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true
      }
    },
    yaxis: {
      title: {
        text: "Header Field"
      },
      min: 0,
      max: 100
    },
    xaxis: {
      type: "category",
      title: {
        text: "Recognition Rate (%)"
      }
    },
    title: {
      text: "Recognition Rate by Field",
      align: "left"
    },
    subtitle: {
      text: "Average across all suppliers for selected date range",
      align: "left"
    },
    colors: [
      "#07445b",
      "#49547b",
      "#77677a",
      "#bf9856",
      "#e28b44",
      "#d46b4f",
      "#bb5055",
      "#9e3a58",
      "#7c285a"
    ],
    legend: {
      show: false
    },
    tooltip: {
      y: {
        formatter: function(value: any) {
          if (value) {
            return value.toString().concat("%");
          }
        }
      }
    },
    noData: {
      text: "No data for selected options",
      align: "center"
    }
  };

  async created() {
    if (this.recogByHeaderFieldData.length === 0) {
      await this.fetchNewChartData();
    }
    this.updateChart();
    this.$emit("chartLoaded");
  }

  async fetchNewChartData() {
    if (this.selectedSite !== "") {
      const chartData: CategoryChartData[] = await invoiceAnalyticsService.loadRecogByHeaderDataAsync(
        this.selectedSite,
        this.dateRange.startDate,
        this.dateRange.endDate,
        "",
        "",
        this.includeVsInRecogRates
      );
      this.recognitionStore.updateRecogByHeaderFieldData(chartData);
    } else {
      this.recognitionStore.updateRecogByHeaderFieldData([]);
    }
  }

  updateChart() {
    this.series = [
      {
        name: "Recognition rate",
        data: this.recogByHeaderFieldData
      }
    ];
  }

  @Watch("searchButtonClicked")
  async updateSearch() {
    await this.fetchNewChartData();
    this.updateChart();
    this.$emit("chartLoaded");
  }
}
